import {NEW_BILLS_BEMOBI_FEATURE_BY_HOST} from 'presentation/constants/newBillsBemobiFeatureByHost';
import {useHostName} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

export const useNewBillsBemobiFeatureFlag = () => {
	const {
		dataHostNameState: {product},
	} = useHostName();

	const flagName = NEW_BILLS_BEMOBI_FEATURE_BY_HOST[product];
	const {isEnabled} = useFeatureFlag(flagName);

	return {
		isEnabled,
	};
};
